(function () {
    'use strict';

    angular.module("imApp").factory("freightRateSetCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getFreightRateSetCreate: function (parms) {
                return $ihttp.post({
                    method: 1539,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1540,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
